import React, { useContext } from 'react'

import { Selectbox } from '../../Form'
import { useTranslation } from '../../../../utils/providers'

import { BundleContext } from '../BundleProvider'

export default function SelectableOptions({
  currentProductId,
  currentSelectedBundle,
  isDisabled = false,
  showValidationError,
}) {
  const { t } = useTranslation()
  const {
    setSelectedOptions,
    selectedOptions,
    options: bundleOptions,
  } = useContext(BundleContext)

  const onChange = (event) => {
    const { name, value } = event.target
    setSelectedOptions(name, value)
  }

  return bundleOptions.map((option, index) => {
    const selections = option.selections
    const isErrorVisible =
      showValidationError &&
      option.errorVisible &&
      currentProductId === currentSelectedBundle

    const formData = {
      name: option.id,
      value: selectedOptions[option.id] || '',
      error: isErrorVisible ? t('THIS_IS_A_REQUIRED_FIELD') : null,
    }

    const options = [
      { label: t('SELECT_BOX_DEFAULT_OPTION'), value: '' },
    ].concat(selections.map(({ id, name }) => ({ label: name, value: id })))

    const htmlId = `bundle_option_${option.id}`

    return (
      <div key={`${index}-${option.id}`} className="option-wrap mb-3">
        <label htmlFor={htmlId} className="font-weight-semi-bold mb-0">
          {option.title}
        </label>
        <Selectbox
          id={htmlId}
          data={formData}
          options={options}
          onChange={onChange}
          disabled={isDisabled}
          materialDesign={false}
        />
      </div>
    )
  })
}
